import request from '../utils/request'
export function getPipeOverview(params) {
  return request({
    url: '/gis/one/map/getPipeOverview',
    method: 'get',
    params
  })
}